import Axios from "axios";
import { API_SERVER } from "../config/constant";
import { toast } from "@chakra-ui/react";

const axios = Axios.create({
  baseURL: `${API_SERVER}`,
  headers: { "Content-Type": "application/json" },
  withCredentials: true, 
});

axios.interceptors.request.use(
  (config) => {
    return Promise.resolve(config);
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("user");
      window.location.href = "/auth/sign-in";

      toast({
        title: "Session Expired",
        description: "Please sign in again",
        status: "error",
      });

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default axios;
